<template>
  <div class="login-form">
    <div class="login-type user-inform" v-show="!isLogin">
      <router-link to="/favourite" class="type-icon"><i class="fas fa-heart"></i>{{ $t('text.favourite') }}</router-link>
      <router-link to="/login" class="type-icon"><i class="fa-solid fa-right-to-bracket"></i>{{ $t('loginForm.login') }}</router-link>
      <router-link to="/registers" class="type-icon"><i class="fa-solid fa-user-plus"></i>{{ $t('loginForm.register') }}</router-link>
    </div>
    <div class="user-inform" v-show="isLogin">
      <router-link to="favourite" class="type-icon"><i class="fas fa-heart"></i>{{ $t('text.favourite') }}</router-link>
      <el-dropdown class="login-type">
        <span class="el-dropdown-link">
          <router-link to="" class="type-icon"> <el-avatar :size="16" :src="url" /> {{ name }}</router-link>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- <el-dropdown-item @click="inform">
              <i class="fa-solid fa-user-tie"></i> Thông tin người sử dụng
            </el-dropdown-item> -->
            <el-dropdown-item @click="changePassword">
              <i class="fa-solid fa-user-shield"></i> {{ $t('text.changePass') }}
            </el-dropdown-item>
            <el-dropdown-item @click="logOut">
              <i class="fa-solid fa-arrow-right-from-bracket"></i> {{ $t('loginForm.logout') }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, computed } from "vue";
import store from "@/store/index";
import { useRouter } from "vue-router";
import { COOKIE_USERS_SESSION } from "@/const/cookie";
import commons from "@/utils/Common";
const router = useRouter();
const name = ref("");
const url = ref("");

const isNotLogin = ref(false);
const isLogin = ref(false);
const logOut = async () => {
  commons.logOut()
  await loadData()
  router.push({ path: "./" });
};

const isLoadLogin = computed(() => {
  return store.getters.isLoadLogin;
});
const changePassword = async () => {
  router.push({ path: "/password" });
};
onMounted( async () => {
  await loadData()
});

const loadData = () => {
  let user = commons.getCookies(COOKIE_USERS_SESSION);
  if (user != null && user != undefined) {
    name.value = user.name;
    url.value = user.urlAvatar;
  } 
  // else {
  //   isNotLogin.value = true
  //   isLogin.value = false
  // }
  isLogin.value = commons.checkLogin()
}

watch(isLoadLogin, async (newValue, oldValue) => {
  await loadData()
});
</script>

<style scoped>
span.lable {
  align-self: flex-end;
  padding-left: 5px;
}

.user-name {
  padding-bottom: 10px !important;
  padding-right: 5px !important;
  background: none !important;
}

/* .login-form a {
  color: #9E9E9E;
} */
.user-inform {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.user-inform a {
  padding: 5px;
  /* font-size: 1rem; */
  /* color: var(--default-header-color); */
  color: #aaa
}
.login-type {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.login-type a {
  padding: 5px;
}

.type-icon i {
  padding-right: 5px;
}

/* .login-type > div {
  text-align: center;
}

.login-type > div:not(:last-child) {
  border-right: 1px solid var(--el-border-color);
} */
</style>
